/**
 * EventSystem Service
 *
 * @implements EventSystem.subscribe("event_name", Function)
 * @implements EventSystem.unsubscribe("event_name", Function)
 * @implements EventSystem.publish("event_name", ...arguments)
 */

type Listener = (...args: any[]) => void;

type Events = {
  [event: string]: Listener[];
};

class EventEmitter {
  private readonly events: Events = {};

  public subscribe(event: string, listener: Listener): any {
    if (typeof this.events[event] !== "object") {
      this.events[event] = [];
    }

    this.events[event].push(listener);
    return () => this.unsubscribe(event, listener);
  }

  public unsubscribe(event: string, listener: Listener): any {
    if (typeof this.events[event] !== "object") {
      return;
    }
    const index = this.events[event].indexOf(listener);
    if (index > -1) {
      this.events[event].splice(index, 1);
    }
  }

  public publish(event: string, ...args: any[]): any {
    if (typeof this.events[event] !== "object") {
      return;
    }
    this.events[event].forEach((listener: Listener) =>
      listener.apply(this, args)
    );
  }
}

const EventSystem = new EventEmitter();

export default EventSystem;
